import { useEffect, useState } from 'react';
import { GET_ALL_CUSTOM_REPORTS } from 'api/endpoints';
import apiFetch from 'api/fetch';
import { getToken } from '@pwr/auth-provider';

export function useAllCustomReports() {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const options = {
      headers: {
        Authorization: getToken(),
        'Content-type': 'application/json',
      },
    };
    const fetchData = () => {
      apiFetch(GET_ALL_CUSTOM_REPORTS, options)
        .then(response => response.json())
        .then(json => {
          setResponse(json);
          setIsLoading(false);
        })
        .catch(setError);
    };
    fetchData();
  }, []);
  return { error, isLoading, response };
}
